import { ReactiveFormsModule } from "@angular/forms";
import { NgModule, APP_INITIALIZER, Injector } from "@angular/core";
import { BrowserAnimationsModule } from "@angular/platform-browser/animations";
import { RouterModule } from "@angular/router";
import { HttpModule } from "@angular/http";
import { HttpClientModule, HTTP_INTERCEPTORS } from "@angular/common/http";
import { APP_BASE_HREF } from "@angular/common";
import { FormsModule } from "@angular/forms";
import { CommonModule } from "@angular/common";
import { Router, Params, ActivatedRoute } from "@angular/router";
import {
  Component,
  OnInit,
  ViewEncapsulation,
  NgZone,
  enableProdMode,
} from "@angular/core";
enableProdMode();
import { SafePipe } from "./app.component";

import { AppRoutes } from "./app.routing";
import { AppComponent } from "./app.component";
import { SidebarModule } from "./sidebar/sidebar.module";
import { FooterModule } from "./shared/footer/footer.module";
import { NavbarModule } from "./shared/navbar/navbar.module";
import { FixedpluginModule } from "./shared/fixedplugin/fixedplugin.module";
import { AdminLayoutComponent } from "./layouts/admin/admin-layout.component";
import { AuthLayoutComponent } from "./layouts/auth/auth-layout.component";
import { NgbPagination, NgbModal } from "@ng-bootstrap/ng-bootstrap";
import { NgbModule } from "@ng-bootstrap/ng-bootstrap";
import { DinamicvaluesComponent } from "./dinamicvalues/dinamicvalues.component";

import {
  MatAutocompleteModule,
  MatButtonModule,
  MatBadgeModule,
  MatButtonToggleModule,
  MatCardModule,
  MatCheckboxModule,
  MatChipsModule,
  MatDialogModule,
  MatExpansionModule,
  MatGridListModule,
  MatIconModule,
  MatInputModule,
  MatListModule,
  MatMenuModule,
  MatDatepickerModule,
  MatNativeDateModule,
  MatPaginatorModule,
  MatProgressBarModule,
  MatProgressSpinnerModule,
  MatRadioModule,
  MatRippleModule,
  MatSelectModule,
  MatSidenavModule,
  MatSliderModule,
  MatSlideToggleModule,
  MatSnackBarModule,
  MatSortModule,
  MatTableModule,
  MatTabsModule,
  MatToolbarModule,
  MatTooltipModule,
  MatStepperModule,
  MatDividerModule,
  MatTreeModule
} from '@angular/material';
import { ChartsModule } from 'ng2-charts';

//import { AppPasswordDirective } from './Admin/app-password.directive';
//import  *  as  data_settingMAO  from  './MAOSetting.json';

//import { DashboardsComponent } from './dashboards/dashboards.component';
// import { Opcion1Component } from './Admin/opcion1/opcion1.component'

/* **** 2025-10-08 JBDCR: Explicit Import for the service and interceptor */
import { UsersAuthService } from './users-auth.service';
import { AuthInterceptor } from './interceptors/auth.interceptor';
/* **** FIN FIX */

/* **** 2025-10-08 JBDCR:
   APP_INITIALIZER using Injector:
   - Resolve UsersAuthService inside the callback to avoid it being undefined.
*/
export function initSessionListenersFactory(injector: Injector) {
  return () => {
    const auth = injector.get(UsersAuthService);
    auth.initSessionListeners();
  };
}
/* **** FIN FIX */

@NgModule({
  exports: [
    MatAutocompleteModule,
    MatButtonModule,
    MatButtonToggleModule,
    MatCardModule,
    MatCheckboxModule,
    MatChipsModule,
    MatStepperModule,
    MatDatepickerModule,
    MatDialogModule,
    MatDividerModule,
    MatExpansionModule,
    MatGridListModule,
    MatIconModule,
    MatInputModule,
    MatListModule,
    MatMenuModule,
    MatNativeDateModule,
    MatPaginatorModule,
    MatProgressBarModule,
    MatProgressSpinnerModule,
    MatRadioModule,
    MatRippleModule,
    MatSelectModule,
    MatSidenavModule,
    MatSliderModule,
    MatSlideToggleModule,
    MatSnackBarModule,
    MatSortModule,
    MatTableModule,
    MatTabsModule,
    MatToolbarModule,
    MatTooltipModule,
    MatTreeModule,
    MatBadgeModule,
  ],
  declarations: [DinamicvaluesComponent],
  // declarations: [AppPasswordDirective],
  //declarations: [DashboardsComponent],

  // declarations: [ Opcion1Component]
})
export class MaterialModule { }

@NgModule({
  imports: [
    CommonModule,
    BrowserAnimationsModule,
    FormsModule,
    RouterModule.forRoot(AppRoutes, { onSameUrlNavigation: 'reload' }),
    //RouterModule.forRoot(AppRoutes),
    HttpModule,
    MaterialModule,
    MatNativeDateModule,
    SidebarModule,
    NavbarModule,
    FooterModule,
    FixedpluginModule,
    HttpClientModule,
    NgbModule.forRoot(),
    ReactiveFormsModule,
    ChartsModule,
  ],
  declarations: [
    AppComponent,
    AdminLayoutComponent,
    AuthLayoutComponent,
    SafePipe,
  ],
  exports: [RouterModule],
  //entryComponents: [ModalComponent],
  bootstrap: [AppComponent],
  providers: [
    /* **** 2025-10-08 JBDCR: APP_INITIALIZER based on Injector */
    {
      provide: APP_INITIALIZER,
      useFactory: initSessionListenersFactory,
      deps: [Injector],
      multi: true
    },
    /* **** 2025-10-08 JBDCR: Register the interceptor */
    {
      provide: HTTP_INTERCEPTORS,
      useClass: AuthInterceptor,
      multi: true
    }
  ]
})
export class AppModule { }
